// Простые SVG-иконки для маркеров в строке скринера. Размер фиксированный
// 14×14, цвет — currentColor (наследуется от родителя). Состояния замочка —
// outline (idle) и filled body (hidden), чтобы было видно «два явных режима»
// без надежды на эмодзи-рендеринг ОС.

export function LockIcon({ hidden }: { hidden: boolean }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      {/* shackle */}
      <path
        d="M8 11V7a4 4 0 0 1 8 0v4"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
      />
      {/* body */}
      <rect
        x="5"
        y="11"
        width="14"
        height="10"
        rx="2"
        fill={hidden ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={1.6}
      />
      {hidden && (
        <circle cx="12" cy="16" r="1.4" fill="var(--paper, #fff)" />
      )}
    </svg>
  );
}

export function PortfolioIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      {/* handle */}
      <path
        d="M9 7V5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 5v2"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
      />
      {/* body */}
      <rect
        x="3"
        y="7"
        width="18"
        height="13"
        rx="2"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.6}
      />
      {/* clasp */}
      <line
        x1="3"
        y1="13"
        x2="21"
        y2="13"
        stroke="var(--paper, #fff)"
        strokeWidth={1.4}
      />
    </svg>
  );
}
